import { FormsEnum } from 'app/shared/enums';
import { ScrollService } from 'app/services/scroll.service';

const scrollOffsetY = {
  [FormsEnum.CalculationForm]: {
    portrait: 150,
    landscape: 240,
  },
  [FormsEnum.SkpRegistrationForm]: {
    portrait: 100,
    landscape: 100,
  },
  [FormsEnum.TerminationGeneratorForm]: {
    portrait: 180,
    landscape: 350,
  },
  'rest-of-the-forms': {
    portrait: 180,
    landscape: 270,
  },
};

export const scrollToFirstInvalidField = (formName: FormsEnum) => {
  const invalidFields = document.querySelectorAll('[data-field-error]');
  const firstInvalidField = invalidFields[0] as HTMLElement;
  const pageContentWrapper = document.querySelectorAll('.PageContentWrapper');
  const pageContentWrapperContener = pageContentWrapper[0] as HTMLElement;
  const isDeviceLandscape = window.window.matchMedia('(orientation: landscape)')
    .matches
    ? 'landscape'
    : 'portrait';

  const offsetY = scrollOffsetY[formName] ?? scrollOffsetY['rest-of-the-forms'];

  if (firstInvalidField && pageContentWrapperContener) {
    const firstInvalidFieldTop =
      firstInvalidField.getBoundingClientRect().top -
      pageContentWrapperContener.getBoundingClientRect().top +
      offsetY[isDeviceLandscape];

    ScrollService.scrollAndFocus(firstInvalidField, firstInvalidFieldTop);
  }
};
